export default "__VITE_PUBLIC_ASSET__adf2eb82__"